import React, { memo } from "react";

import {
  Rating as MUIRating,
  RatingProps as MUIRatingProps,
} from "@mui/material";

export type RatingProps = MUIRatingProps & {
  dataId: string;
};

export const Rating = memo(({ dataId, ...restProps }: RatingProps) => {
  return <MUIRating data-id={dataId} {...restProps} />;
});
